module.exports = __webpack_public_path__ + "static/media/calcadaLogo.f59b25d7.svg";